import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import {CouponExtensionContainerModel} from '../../../../../../models/aggregates/erp/coupon';

@Injectable({providedIn: 'root'})
export class CouponExtService extends BaseApiTemplateService<CouponExtensionContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'coupons-exts';
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + 'coupons-exts';
    this.httpClient = http;
  }

}
